import { useState, useEffect } from "react";

export const KEY = `fcc91573`; // API KEY

export function useMovies(query) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [movies, setMovies] = useState([]);

  //DONT SET STATE IN API FETCHING WITHOUT USEEFFECT AS IT CREATES AN INF LOOP!

  //useEffect creates a place where we can cause a side effect and make api calls, second arg => Dependancy array -> currently [] which means it will only render on initial render

  // code runs AFTER the component has been painted to the UI

  // with [query], useEffect is executed each time the state changes as well as after the inital render
  useEffect(
    function () {
      // Browser API for cleaning up unnecessary fetch request, which otherwise would slow down the app
      const controller = new AbortController();

      async function fetchMovies() {
        try {
          setError("");
          setIsLoading(true);
          const res = await fetch(
            `https://www.omdbapi.com/?apikey=${KEY}&s=${query}`,
            { signal: controller.signal }
          );
          if (!res.ok) throw new Error("Something went wrong :(");

          const data = await res.json();

          // if no movies are found, api returns an object containing the following (Response, Error)
          if (data.Response === "False") throw new Error(data.Error);
          setMovies(data.Search);
          setError("");
        } catch (error) {
          if (error.name !== "AbortError") setError(error.message);
        } finally {
          setIsLoading(false);
        }
      }

      if (query.length < 3) {
        setMovies([]);
        setError("");
        return;
      }

      fetchMovies();

      return function () {
        // each time there is a key stroke, function gets executed and controller aborts the current fetching request as the new one comes in
        controller.abort();
      };
    },
    [query]
  );

  return { movies, isLoading, error };
}
